import store from "../../store";
import {keepAlive, toLoginPages} from "../../constant";
import utils from "../../utils";

//缓存页面
export function keepAlivePage(to, from, next) {
    const toName = to.name;
    const fromName = from.name;
    const listPage = Object.keys(keepAlive) || [];
    const detailPage = keepAlive[from.name] || [];
    if (detailPage.includes(toName) && listPage.includes(fromName)) {
        store.commit("changeAlivePage", [from.name]);
    } else if (listPage.includes(toName)) {
        store.commit("changeAlivePage", [to.name]);
    } else {
        store.commit("changeAlivePage", []);
    }
    next();
}

export function intercept(to, from, next) {
    console.log(to, from)
    const toName = to.name;
    const fromName = from.name;
    const toQuery = to.query;
    // 只在当前路由没有tenantId时，才从之前的路由继承
    if (from.query.tenantId && !toQuery.tenantId) {
        Object.assign(toQuery, {tenantId: from.query.tenantId}) 
    }
    // 只在当前路由没有lang时，才从之前的路由继承
    if (from.query.lang && !toQuery.lang) {
        Object.assign(toQuery, {lang: from.query.lang}) 
    }

    if(from.name) {
        store.commit("addRouterHistory", [...store.state.routerHistory, {
            name: to.name,
            path: to.path,
            query: to.query,
            params: to.params
        }])
    }

    let keepCurrentPages = ["login", "loginText", "loginEmail", "retrieve", "registerEmail"]
    if(!store.getters.isLogin&&toName!=='appointment' && toLoginPages.includes(toName)) {
        return utils.toLogin()
    }

    if(!keepCurrentPages.includes(toName)) {
        store.commit("saveCurrent", null)
    }

    // 判断后退是登录页面并且已登录，则继续后退
    if(store.state.common.isBack) {
        if(to.path.includes('login')) {
            return utils.back()
        }else {
            store.commit("common/changeIsBack", false);
        }
    }

    // 必须调用next()来继续导航
    next();
}


// WEBPACK FOOTER //
// ./src/router/middleware/index.js